export enum TemplateFieldType {
  DATE_SIGNED = 'date-signed',
  INITIAL = 'initial',
  SIGNATURE = 'signature',
  TEXT = 'text',
}

export enum VariableMappingType {
  CUSTOM = 'custom',
  SYSTEM = 'system',
}
